<!-- Schedule Ui -->
<!-- 
{{scheduleForm?.value | json}}
{{scheduleForm?.get(['date', 'end', 'value'])?.value | json}} -->
<div class="cards-wrapper flex-wrap gap-30 mt-18 " style="
 flex-wrap: wrap;
justify-content: flex-start; display: flex;
">
    <mat-card class="gon" style="box-sizing: border-box; width: 800px;
  position: relative;
max-height: max-content;
height: 100%;
padding-bottom: 0px;
overflow-y: auto;
max-width: 100%;
">

        <mat-card-header class="p-12">
            <!-- <mat-card-title>Availability Form</mat-card-title>
            <mat-card-subtitle>Set your Availability</mat-card-subtitle> -->
        </mat-card-header>
        <mat-card-content>
            @if (isAdmin) {
                <mat-accordion class="settings-accordion">
                    <mat-expansion-panel [expanded]="!settingsConfigured">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Organization Shift Settings</mat-panel-title>
                            <!-- <mat-panel-description>Configure standard shift hours</mat-panel-description> -->
                        </mat-expansion-panel-header>

                        @if (settingsForm) {
                            <form [formGroup]="settingsForm" class="g-just-flex flex-wrap gap-15 mt-10">
                                <div class="g-just-flex gap-15 align-items-center" style="width: 100%;">
                                    <div style="width: 150px;"><strong style="color: var(--mat-sys-primary)">Morning Shift</strong></div>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>Start</mat-label><input matInput type="time" formControlName="morningStart"></mat-form-field>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>End</mat-label><input matInput type="time" formControlName="morningEnd"></mat-form-field>
                                </div>
                                <div class="g-just-flex gap-15 align-items-center" style="width: 100%;">
                                    <div style="width: 150px;"><strong style="color: var(--mat-sys-primary)">Afternoon Shift</strong></div>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>Start</mat-label><input matInput type="time" formControlName="afternoonStart"></mat-form-field>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>End</mat-label><input matInput type="time" formControlName="afternoonEnd"></mat-form-field>
                                </div>
                                <div class="g-just-flex gap-15 align-items-center" style="width: 100%;">
                                    <div style="width: 150px;"><strong style="color: var(--mat-sys-primary)">Night Shift</strong></div>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>Start</mat-label><input matInput type="time" formControlName="nightStart"></mat-form-field>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>End</mat-label><input matInput type="time" formControlName="nightEnd"></mat-form-field>
                                </div>
                                <div class="g-just-flex gap-15 align-items-center" style="width: 100%;">
                                    <div style="width: 150px;"><strong style="color: var(--mat-sys-primary)">Morning Ward Round</strong></div>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>Start</mat-label><input matInput type="time" formControlName="wardRoundStart"></mat-form-field>
                                    <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -15px;"><mat-label>End</mat-label><input matInput type="time" formControlName="wardRoundEnd"></mat-form-field>
                                </div>
                                
                                @if(settingsForm.hasError('wardRoundOutsideShift')) {
                                    <div class="small-subtitle" style="color: var(--mat-sys-error); width: 100%;">
                                        Ward round time must fall completely within the Morning or Afternoon shift.
                                    </div>
                                }
                                @if(settingsForm.hasError('shiftOverlap')) {
                                    <div class="small-subtitle" style="color: var(--mat-sys-error); width: 100%;">
                                        Shifts cannot overlap with each other. Please ensure sequential start/end times.
                                    </div>
                                }

                                <div style="width: 100%; display: flex; justify-content: flex-end; margin-top: 10px;">
                                    <button mat-flat-button color="primary" type="button" [disabled]="!settingsForm.valid || isSavingSettings" (click)="saveSettings()">
                                        {{ isSavingSettings ? 'Saving...' : 'Save Settings' }}
                                    </button>
                                </div>
                            </form>
                        }
                    </mat-expansion-panel>
                </mat-accordion>
            }
            <div class="gap m-5"></div>
            @if(scheduleForm) {
            <form [formGroup]="scheduleForm" class="schedule-form-2">

                @if(isAdmin && mode === 'create') {
                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">
                        <span>Practitioner</span>
                    </div>
                    <div class="sub-section-wrapper" style="padding: 12px;">
                        <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>Schedule is for</mat-label>
                            <mat-select [value]="selectedPractitionerReference"
                                (valueChange)="onPractitionerSelected($event)">
                                @for(practitioner of practitionerOptions; track practitioner.reference) {
                                <mat-option [value]="practitioner.reference">
                                    {{ practitioner.display }}
                                </mat-option>
                                }
                            </mat-select>
                                                  </mat-form-field>
                        @if(loadingPractitioners) {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            Loading practitioners...
                        </div>
                        } @else if(practitionerOptions.length === 0) {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            No practitioners found for this organization.
                        </div>
                        } @else {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            @if(isSelectedPractitionerLoggedInUser) {
                            Creating schedule for <strong>yourself</strong> ({{ selectedPractitionerDisplay }}).
                            } @else {
                            Creating schedule for <strong>{{ selectedPractitionerDisplay }}</strong>.
                            }
                        </div>
                        }
                    </div>
                </div>
                <mat-divider></mat-divider>
                }



                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">

                        <span>Date</span>
                        @if(subGroupsVisibility.date) {
                        <mat-icon (click)="subGroupsVisibility.date = false" class="small-icon">expand_less</mat-icon>
                        } @else {
                        <mat-icon (click)="subGroupsVisibility.date = true" class="small-icon">expand_more</mat-icon>
                        }
                    </div>
                    <div class="sub-section-wrapper" formGroupName="date" style="overflow: hidden;"
                        [style.height]="subGroupsVisibility.date ? 'auto' : '0px'"
                        [style.padding]="subGroupsVisibility.date ? '12px' : '0px'"
                        [style.transition]="'0.3s ease-in-out'" [style.transitionProperty]="'height'">
                        <div class="start-date-form mb-20">
                            <label for="startDate" class="mb-5" style="display: block;">Start Date</label>
                            <mat-form-field appearance="outline" style=" display: block;">
                                <input matInput [matDatepicker]="pickerSD" placeholder="01/30/2025"
                                    formControlName="start" [min]="todayMinDate">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="pickerSD"></mat-datepicker-toggle>
                                <mat-datepicker #pickerSD></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="end-date-form" formGroupName="end">
                            <div class="form-group-label">End Date</div>
                            <mat-radio-group formControlName="type" class="radio-group ">
                                <div class="radio-with-options g-just-flex gap-12
                            justify-content-start
                            ">
                                    <!-- <mat-radio-button [value]="'specific_date'"
                                        style="margin-bottom: 20px;"></mat-radio-button> -->
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                        <input matInput placeholder="01/30/2025" [matDatepicker]="pickerSDV"
                                            formControlName="value" [min]="endMinDate">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerSDV"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerSDV></mat-datepicker>
                                    </mat-form-field>

                                    @if(planningHorizonConflictCheckFailed) {
                                    <div class="small-subtitle" style="color: var(--mat-sys-error); margin-top: -6px;">
                                        Could not verify schedule conflicts. Check connection.
                                    </div>
                                    }

                                    @if(hasPlanningHorizonConflict) {
                                    <div class="small-subtitle" style="color: var(--mat-sys-error); margin-top: -6px;">
                                        Planning horizon conflicts with {{planningHorizonConflictSchedules.length}}
                                        existing schedule(s).
                                    </div>
                                    }
                                </div>
                                <div class="gap m-3"></div>
                                <!-- <div class="radio-with-options g-just-flex gap-12 justify-content-start">

                                    <mat-radio-button [value]="'indefinite'" style="margin-bottom: 0px;">Indefinite Into
                                        the Future</mat-radio-button>
                                </div> -->





                            </mat-radio-group>
                        </div>

                    </div>



                </div>
                <mat-divider></mat-divider>

                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between; max-width: 100%;
                box-sizing: border-box;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">

                        <div>
                            <div>Date Recurrence Pattern</div>
                            <span class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                                Set available days between the chosen date range
                            </span>


                        </div>
                        @if(subGroupsVisibility.dateRecurrence) {
                        <mat-icon (click)="subGroupsVisibility.dateRecurrence = false" class="small-icon"
                            style="overflow: visible;">expand_less</mat-icon>
                        } @else {
                        <mat-icon (click)="subGroupsVisibility.dateRecurrence = true" class="small-icon"
                            style="overflow: visible;">expand_more</mat-icon>
                        }
                    </div>
                    <div class="sub-section-wrapper" formGroupName="dateRecurrence" style=" overflow: hidden;"
                        [style.height]="subGroupsVisibility.dateRecurrence ? 'auto' : '0px'"
                        [style.padding]="subGroupsVisibility.dateRecurrence ? '12px 0px' : '0px'"
                        [style.transition]="'0.3s ease-in-out'" [style.transitionProperty]="'height'">
                        <!-- <div class="start-date-form mb-20"> -->
                        <mat-radio-group formControlName="type" class="radio-group ">
                            <div class="radio-with-options g-just-flex
                            justify-content-start
                            ">
                                <mat-radio-button [value]="'mon_fri'" style="margin-bottom: 12px;">Monday -
                                    Friday</mat-radio-button>


                            </div>
                            <div class="gap"></div>
                            <div class="radio-with-options g-just-flex justify-content-start">

                                <mat-radio-button [value]="'all_days'" style="margin-bottom: 12px;">All
                                    Days</mat-radio-button>

                            </div>
                            <div class="radio-with-options g-just-flex justify-content-start">

                                <mat-radio-button [value]="'weekdays'">
                                    Some days of every week
                                </mat-radio-button>
                            </div>
                            @if(scheduleForm.get(['dateRecurrence', 'type'])?.value === "weekdays"){
                            <div class="weekdays-selection-wrapper">
                                <div class="section-subtitle my-12" style="font-size: 1rem;">
                                    Select Days
                                </div>
                                <mat-chip-listbox [multiple]="true"
                                    (change)="setValue($event, scheduleForm!.get(['dateRecurrence', 'value'])!)"
                                    class="chip-list">
                                    @for(option of ['Monday', "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
                                    "Sunday"]; track $index;){
                                    <mat-chip-option value="{{option}}">

                                        {{option}}
                                    </mat-chip-option>
                                    }



                                </mat-chip-listbox>
                            </div>
                            }






                        </mat-radio-group>
                        <!-- </div> -->


                    </div>



                </div>





                <mat-divider></mat-divider>

                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">

                        <span>Weekly Time Slots</span>
                        @if(subGroupsVisibility.time) {
                        <mat-icon (click)="subGroupsVisibility.time = false" class="small-icon">expand_less</mat-icon>
                        } @else {
                        <mat-icon (click)="subGroupsVisibility.time = true" class="small-icon">expand_more</mat-icon>
                        }
                    </div>

                    <div class="sub-section-wrapper" formGroupName="timePerWeekday" style="overflow: hidden;"
                        [style.height]="subGroupsVisibility.time ? 'auto' : '0px'"
                        [style.padding]="subGroupsVisibility.time ? '12px' : '0px'"
                        [style.transition]="'0.3s ease-in-out'" [style.transitionProperty]="'height'">

                        @if(selectedWeekdays.length === 0) {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            Select a recurrence pattern above to choose weekdays.
                        </div>
                        } @else {

                        @for(weekday of selectedWeekdays; track weekday){
                        <div class="mb-20"
                            style="border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; padding: 12px;">
                            <div class="g-just-flex" style="justify-content: space-between; align-items: center;">
                                <div style="font-weight: 600;">{{weekday}}</div>
                                <div class="g-just-flex gap-6">
                                </div>
                            </div>

                            <div class="gap my-10"></div>

                            <div [formArrayName]="weekday">
                                @for(slotGroup of getSlotsArray(weekday).controls; track slotGroup; let index = $index){
                                <div class="g-just-flex gap-2" style="align-items: flex-start;
                                flex-direction: column; box-sizing: border-box;;
                                " [formGroupName]="$index">
                                    <div class="g-just-flex gap-6" style="width: 100%; align-items: flex-start;
                                    justify-content: space-between;
                                flex-direction: row; box-sizing: border-box;">
                                        
                                        <mat-form-field appearance="outline" style="flex: 1;" floatLabel="always">
                                            <mat-label>Shift Type</mat-label>
                                            <mat-select formControlName="shiftType" (selectionChange)="onShiftTypeChange(weekday, index)">
                                                <mat-option value="morning">Morning Shift</mat-option>
                                                <mat-option value="afternoon">Afternoon Shift</mat-option>
                                                <mat-option value="night">Night Shift</mat-option>
                                                <mat-option value="explicit">Custom Time</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        @if(slotGroup.get('shiftType')?.value === 'explicit') {
                                        <mat-form-field appearance="outline" style="flex: 1;" floatLabel="always">
                                            <mat-label>Start</mat-label>
                                            <input matInput type="time" formControlName="start" style="font-size: 14px;">
                                            @if(slotGroup.errors?.['timeRangeOrder']){
                                            <mat-error>Start must be before end</mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" style="flex: 1;" floatLabel="always">
                                            <mat-label>End</mat-label>
                                            <input matInput type="time" formControlName="end" style="font-size: 14px;">
                                        </mat-form-field>
                                        }

                                        @if(slotGroup.get('shiftType')?.value === 'explicit') {
                                        <mat-form-field appearance="outline" style="flex: 1;" floatLabel="always">
                                            <mat-label>Duty Type</mat-label>
                                            <mat-select formControlName="dutyType">
                                                <mat-option value="outpatient-consultation">Outpatient Clinic</mat-option>
                                                <mat-option value="ward-round">Ward Rounds</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        }
                                    </div>
                                    <div class="action-buttons-group mb-15 g-just-flex justify-content-end mx-4"
                                        style="    margin-top: -20px; width: 100%;">

                                        <button mat-icon-button type="button"
                                            (click)="addSlotAtNextIndex(weekday, index)" aria-label="Add slot">
                                            <span class="material-symbols-outlined"
                                                style="font-size: 16px; height: 16px; line-height: 16px; width: 16px;">
                                                add
                                            </span>

                                        </button>



                                        <button mat-icon-button type="button"
                                            (click)="removeSlotAtIndex(weekday, index)" aria-label="Remove slot">
                                            <span class="material-symbols-outlined"
                                                style="font-size: 16px; height: 16px; line-height: 16px; width: 16px;">
                                                delete
                                            </span>

                                        </button>
                                    </div>


                                </div>

                                @if(getSlotsArray(weekday).errors?.['overlappingTimeRanges']){
                                <div class="small-subtitle" style="color: var(--mat-sys-error); margin-top: -6px;">
                                    Slots overlap within {{weekday}}.
                                </div>
                                }
                                }
                            </div>
                        </div>
                        }
                        }

                    </div>

                </div>

                <!-- Form fields for schedule creation go here -->
            </form>



            }
        </mat-card-content>
        <div class="abs-pos py-6 px-12 g-just-flex gap-15" style="justify-content: flex-end;">
            @if (isSaving) {
                <div style="flex: 1; padding: 0 20px;">
                    <div style="font-size: 12px; margin-bottom: 4px; color: var(--mat-sys-primary);">
                        Saving slots: {{savingProgress}} / {{savingTotal}}
                    </div>
                    <mat-progress-bar mode="determinate" [value]="(savingProgress / savingTotal) * 100"></mat-progress-bar>
                </div>
            }
            <button mat-button [disabled]="isSaving"> Cancel</button>
            <button mat-flat-button type="button" [disabled]="isSaving" (click)="save()"> Save</button>
        </div>
    </mat-card>
</div>

<mat-menu #slotSplitMenu="matMenu">
    @for(duration of slotSplitDurations; track duration){
    <button mat-menu-item type="button" (click)="handleSplitSelection(duration)">
        Split into {{duration}} min blocks
    </button>
    }
</mat-menu>
